/* eslint-disable import/prefer-default-export */
import * as React from "react";

/**
 * Renders text that is visually hidden but included for accessibility concerns (i.e. for screen readers).
 */
export function VisuallyHidden({ children }: React.PropsWithChildren<object>) {
  return <span className="sr-only">{children}</span>;
}
